/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Asteroid = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg
    viewBox="0 0 132 132"
    ref={ref}
    css={{
      color: "#F4F6F8",
      height: "132px",
      width: "132px",
    }}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle cx={66} cy={66} r={66} fill="currentColor" />
      <path
        fill="#74B0F4"
        d="M64.357 75.717a4.956 4.956 0 0 1 6.54-2.53 4.957 4.957 0 0 1 2.53 6.541 4.956 4.956 0 0 1-6.925 2.339"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M75.9 63.8c6.378 0 11.55 5.172 11.55 11.55 0 6.378-5.172 11.55-11.55 11.55-6.378 0-11.55-5.172-11.55-11.55 0-6.378 5.172-11.55 11.55-11.55zM51.399 53.183l4.666 4.666m5.835 1.166l2.333 2.334m6.079-3.254L56.1 44.048m-11.55 11.55l14.095 14.164"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M64.357 75.717a4.956 4.956 0 0 1 6.54-2.53 4.957 4.957 0 0 1 2.53 6.541 4.956 4.956 0 0 1-6.925 2.339"
      />
      <path
        fill="#F18686"
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M84.066 70.884a3.301 3.301 0 0 1 0 6.6 3.301 3.301 0 0 1 0-6.6z"
      />
      <path
        fill="#CAD0D8"
        d="M87 39c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zM17 67c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zm65 45c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zm35-61c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137z"
      />
      <circle cx={75.5} cy={13.5} r={1.5} fill="#CAD0D8" />
      <circle cx={43.5} cy={78.5} r={1.5} fill="#CAD0D8" />
      <circle cx={37.5} cy={15.5} r={1.5} fill="#CAD0D8" />
      <circle cx={106.5} cy={31.5} r={1.5} fill="#CAD0D8" />
      <circle cx={106.5} cy={75.5} r={1.5} fill="#CAD0D8" />
      <circle cx={61.5} cy={102.5} r={1.5} fill="#CAD0D8" />
      <circle cx={38.5} cy={111.5} r={1.5} fill="#CAD0D8" />
      <g transform="translate(21 36)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(56 26)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(27 90)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(105 95)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
    </g>
  </svg>
));
